import { render, staticRenderFns } from "./OrderStatusHistory.vue?vue&type=template&id=d0180d8c"
import script from "./OrderStatusHistory.vue?vue&type=script&lang=js"
export * from "./OrderStatusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports